export default {
  income: {
    totalBarchart: { title: 'Total Income', tooltipTitle: 'Income' },
    topFiveSources: {
      leftToggleTitle: 'Top Income Sources',
      leftToggleLabel: 'Payers',
      leftToggleIcon: 'small-money-bank',
      rightToggleTitle: 'Top Income Categories',
      rightToggleLabel: 'Categories',
      rightToggleIcon: 'small-align-back',
      chartTitle: 'Total',
      legendAmountColumn: 'Amount',
      otherTooltipTitle: 'Other Income Sources',
      otherTooltipContent:
        'This amount is the total income received from all other income sources.',
      otherCategoryTooltipTitle: 'Other Income Categories',
      otherCategoryTooltipContent:
        'This amount is the total income received from all other income categories combined.',
    },
    creditTransactions: { title: 'All Income Transactions' },
  },
  loan: {
    totalBarchart: {
      title: 'Total Loan Repayments',
      tooltipTitle: 'Loan Repayment',
    },
    topFiveSources: {
      leftToggleTitle: 'Loan Providers',
      leftToggleLabel: 'Loan Providers',
      leftToggleIcon: 'small-money-bank',
      rightToggleTitle: 'Loan Categories',
      rightToggleLabel: 'Categories',
      rightToggleIcon: 'small-align-back',
      chartTitle: 'Total Loan Repayments',
      legendAmountColumn: 'Total Repayments',
      otherTooltipTitle: 'Other Loan Providers',
      otherTooltipContent:
        'These are the loan amounts from all other loan providers combined.',
      otherCategoryTooltipTitle: 'Other Loan Categories',
      otherCategoryTooltipContent:
        'These are the loan amounts from all other loan categories combined.',
    },
    creditTransactions: { title: 'All Loan Transactions' },
  },
};
